(function( $, doc ) {
    "use strict";

    (function(){

        $(document).ready(function() {
            
            // Enable date-ui
            $(".wpmudev-input_date").datepicker({
                "dateFormat": "d MM yy",
            });

            // Form style
            $("#forminator-cform-appearance--form_lifespan .wpmudev-tabs-menu").each(function(){

                var $this = $(this),
                    $item = $this.find(".wpmudev-tabs-menu_item"),
                    $input = $item.find("input");
                
                // Default
                $item.find("#forminator-cform-form_expire-date").attr("checked", true);
                $item.find("#forminator-cform-form_expire-date").parent("li").addClass("current");
                $this.next(".wpmudev-tabs-content").find(".wpmudev-tabs-content_item").addClass("current");

                $input.change(function(){

                    $input.attr("checked", false);
                    $input.parent("li").removeClass("current");

                    $(this).attr("checked", true);
                    $(this).parent("li").addClass("current");
                    
                });

            });

        } );
        
    }());
    
}( jQuery, document ));